"use strict";

jQuery(document).ready(function($) {

	var adpPopup = {};

	( function() {
		var $this;

		adpPopup = {
			sPrevious : window.scrollY,
			sDirection: 'down',

			/*
			* Initialize
			*/
			init: function( e ) {
				$this = adpPopup;

				$this.popupInit( e );

				// Init events.
				$this.events( e );
			},

			/*
			* Events
			*/
			events: function( e ) {
				// Custom Events
				$( document ).on( 'click', '.popup-close', $this.closePopup );
				$( document ).on( 'click', '.popup-accept', $this.acceptPopup );
				$( document ).on( 'click', '.popup-accept', $this.closePopup );
				$( document ).on( 'click', '.age-verification__popup-close', $this.agePopup );
				$( document ).on( 'click', '.age-verification__popup-close', $this.closePopup );
				$( document ).on( 'click', '.age-verification__button-no', $this.ageDeclined );

				// Checking this will cause popup to close when user presses key.
				$( document ).keyup(function(e) {
					// Press ESC to Close.
					if ( e.key === 'Escape' ) {
						$( '.popup-open[data-esc-close="true"]' ).each(function(index, popup) {
							$this.closePopup(popup);
						});
					}

					// Press F4 to Close.
					if ( e.key === 'F4' ) {
						$( '.popup-open[data-f4-close="true"]' ).each(function(index, popup) {
							$this.closePopup(popup);
						});
					}
				});

				// Checking this will cause popup to close when user clicks on overlay.
				$( document ).on( 'click', '.popup-overlay', function( e ) {
					$( '.popup-open[data-overlay-close="true"]' ).each(function(index, popup) {
						$this.closePopup(popup);
						//$this.closePopup( $( this).prev() );
					})
				} );
			},

			/*
			* Init popup elements
			*/
			popupInit: function( e ) {

				// Set scroll direction.
				$( document ).on( 'scroll', function() {

					let scrollCurrent = window.scrollY;

					// Set scroll temporary vars.
					if ( scrollCurrent > $this.sPrevious ) {
						$this.sDirection = 'down';
					} else {
						$this.sDirection = 'up';
					}

					$this.sPrevious = scrollCurrent;
				});

				$this.bindNewsletterForms();

				// Open popup
				$( '.popup' ).each(function(index, popup) {

					// Manual Launch.
					if ( 'manual' === $( popup ).data( 'open-trigger' ) ) {

						let selector = $( popup ).data( 'open-manual-selector' );

						if ( selector ) {
							$(selector).addClass('popup-trigger')

							$( document ).on( 'click', selector, function( e ) {
								e.preventDefault();

								$( popup ).removeClass( 'popup-already-opened' );

								$this.openPopup( popup );

								if (e.currentTarget.classList.contains('popup')) {
									$this.closePopup(selector);
								}
							} );
						}


					}

					// Checks whether a popup should be displayed or not.
					if ( ! $this.isAllowPopup( popup ) && ! $(popup).hasClass('age-verification')) {
						return;
					}

					$this.openTriggerPopup( popup );
				});
			},

			/*
			* Bind popup newsletter forms so Shopify captcha can AJAX-submit them
			*/
			bindNewsletterForms: function() {
				document.querySelectorAll( '.popup-main form.newsletter-form--popup' ).forEach( function( formEl ) {
					if ( formEl.dataset.popupNewsletterBound === 'true' ) {
						return;
					}

					formEl.dataset.popupNewsletterBound = 'true';
					formEl.setAttribute( 'data-shopify-captcha', 'true' );
					$this.attachNewsletterIframe( formEl );

					// Shopify captcha replaces form.submit after wiring. Assign a native
					// iframe submit first so captcha captures it and calls it with a token.
					// fetch()/XHR to /contact is rejected with 400 even when captcha is valid.
					try {
						formEl.submit = function() {
							$this.postNewsletterFormNative( formEl );
						};
					} catch ( err ) {}

					$this.protectNewsletterForm( formEl );

					formEl.addEventListener( 'submit', function( e ) {
						e.preventDefault();
						e.stopImmediatePropagation();

						if ( $( formEl ).data( 'popup-newsletter-loading' ) ) {
							return;
						}

						if ( typeof formEl.reportValidity === 'function' && ! formEl.reportValidity() ) {
							return;
						}

						$this.markNewsletterSubmitting( formEl );
						$this.runNewsletterCaptchaSubmit( formEl );
					}, true );
				} );
			},

			attachNewsletterIframe: function( formEl ) {
				var name = ( formEl.id || 'PopupNewsletterForm' ) + '-frame';
				var iframe = document.getElementById( name );

				if ( ! iframe ) {
					iframe = document.createElement( 'iframe' );
					iframe.name = name;
					iframe.id = name;
					iframe.title = 'Newsletter';
					iframe.setAttribute( 'aria-hidden', 'true' );
					iframe.tabIndex = -1;
					iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;overflow:hidden;visibility:hidden';
					formEl.parentNode.insertBefore( iframe, formEl.nextSibling );

					iframe.addEventListener( 'load', function() {
						if ( formEl.dataset.popupNewsletterExpecting !== 'true' ) {
							return;
						}

						formEl.dataset.popupNewsletterExpecting = '';

						try {
							var href = iframe.contentWindow.location.href || '';
							if ( href.indexOf( '/challenge' ) !== -1 ) {
								$this.failNewsletterForm( formEl );
								return;
							}
						} catch ( err ) {
							// X-Frame-Options may block reading the response; the POST still ran.
						}

						$this.showNewsletterSuccess( formEl );
					} );
				}

				formEl.setAttribute( 'target', name );
			},

			protectNewsletterForm: function( formEl, callback ) {
				if ( formEl.getAttribute( 'data-hcaptcha-bound' ) === 'true' ) {
					if ( typeof callback === 'function' ) {
						callback();
					}
					return;
				}

				if ( formEl.dataset.cptcha === 'true' && typeof callback === 'function' ) {
					var started = Date.now();
					var wait = function() {
						if ( formEl.getAttribute( 'data-hcaptcha-bound' ) === 'true' ) {
							callback();
							return;
						}

						if ( Date.now() - started > 8000 ) {
							$this.failNewsletterForm( formEl );
							return;
						}

						setTimeout( wait, 50 );
					};
					wait();
					return;
				}

				var captcha = window.Shopify && window.Shopify.captcha;
				if ( captcha && typeof captcha.protect === 'function' ) {
					try {
						captcha.protect( formEl, callback );
						return;
					} catch ( err ) {}
				}

				if ( typeof callback === 'function' ) {
					callback();
				}
			},

			runNewsletterCaptchaSubmit: function( formEl ) {
				var submitWithCaptcha = function() {
					// After protect(), form.submit is Shopify's captcha wrapper.
					// It obtains h-captcha-response, then calls our native iframe submit.
					try {
						formEl.submit();
					} catch ( err ) {
						$this.failNewsletterForm( formEl );
					}
				};

				$this.protectNewsletterForm( formEl, submitWithCaptcha );
			},

			markNewsletterSubmitting: function( formEl ) {
				var $form = $( formEl );
				var $error = $form.find( '[data-popup-newsletter-error]' );
				var $submit = $form.find( '[data-popup-newsletter-submit]' );

				formEl.dataset.popupNewsletterExpecting = 'true';
				$form.data( 'popup-newsletter-loading', true );
				$error.attr( 'hidden', true ).empty();
				$submit.addClass( 'loading' ).attr( 'aria-busy', 'true' );

				setTimeout( function() {
					$submit.prop( 'disabled', true );
				}, 0 );

				if ( $form.data( 'newsletter-fail-timer' ) ) {
					clearTimeout( $form.data( 'newsletter-fail-timer' ) );
				}

				$form.data( 'newsletter-fail-timer', setTimeout( function() {
					if ( $form.data( 'popup-newsletter-loading' ) ) {
						$this.failNewsletterForm( formEl );
					}
				}, 15000 ) );
			},

			failNewsletterForm: function( formEl ) {
				var $form = $( formEl );
				var $error = $form.find( '[data-popup-newsletter-error]' );
				var $submit = $form.find( '[data-popup-newsletter-submit]' );

				formEl.dataset.popupNewsletterExpecting = '';

				if ( $form.data( 'newsletter-fail-timer' ) ) {
					clearTimeout( $form.data( 'newsletter-fail-timer' ) );
					$form.removeData( 'newsletter-fail-timer' );
				}

				$form.data( 'popup-newsletter-loading', false );
				$submit.removeClass( 'loading' ).prop( 'disabled', false ).removeAttr( 'aria-busy' );
				$error
					.removeAttr( 'hidden' )
					.text( 'No pudimos completar tu suscripción. Inténtalo de nuevo.' );
			},

			showNewsletterSuccess: function( formEl ) {
				var $form = $( formEl );
				var $popup = $form.closest( '.popup' );
				var $fields = $form.find( '[data-popup-newsletter-fields]' );
				var $success = $form.find( '[data-popup-newsletter-success]' );
				var $error = $form.find( '[data-popup-newsletter-error]' );
				var $submit = $form.find( '[data-popup-newsletter-submit]' );

				formEl.dataset.popupNewsletterExpecting = '';

				if ( $form.data( 'newsletter-fail-timer' ) ) {
					clearTimeout( $form.data( 'newsletter-fail-timer' ) );
					$form.removeData( 'newsletter-fail-timer' );
				}

				$form.data( 'popup-newsletter-loading', false );
				$error.attr( 'hidden', true ).empty();
				$fields.attr( 'hidden', true );
				$popup.addClass( 'popup-newsletter-success' );
				$success.removeAttr( 'hidden' );
				$submit.removeClass( 'loading' ).prop( 'disabled', true ).removeAttr( 'aria-busy' );

				try {
					$success[0].focus( { preventScroll: true } );
				} catch ( err ) {}

				if ( $popup.data( 'newsletter-close-timer' ) ) {
					clearTimeout( $popup.data( 'newsletter-close-timer' ) );
				}

				var closeTimer = setTimeout( function() {
					if ( $popup.hasClass( 'popup-open' ) ) {
						$this.closePopup( $popup.get( 0 ) || $popup );
					}
				}, 8000 );

				$popup.data( 'newsletter-close-timer', closeTimer );
			},

			postNewsletterFormNative: function( formEl ) {
				var tokenField = formEl.querySelector( '[name="h-captcha-response"]' );
				if ( ! tokenField || ! tokenField.value ) {
					$this.failNewsletterForm( formEl );
					return;
				}

				$this.attachNewsletterIframe( formEl );
				formEl.dataset.popupNewsletterExpecting = 'true';

				// Same request shape as the footer newsletter: a real browser form POST.
				HTMLFormElement.prototype.submit.call( formEl );

				// X-Frame-Options can block the iframe response/load event. If the POST
				// already went out with a captcha token, show success shortly after.
				setTimeout( function() {
					if ( formEl.dataset.popupNewsletterExpecting === 'true' ) {
						formEl.dataset.popupNewsletterExpecting = '';
						$this.showNewsletterSuccess( formEl );
					}
				}, 1200 );
			},

			/*
			* Trigger open popup
			*/
			openTriggerPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;


				var trigger = $( popup ).data( 'open-trigger' );

				// Age Verification.
				if ( 'none' === trigger ) {
					let ageVerification = $this.getCookie( 'popup-age-' + $( popup ).data( 'id' ) || 0 );


					if (!ageVerification) 
						$this.openPopup( popup );
				}

				// Time Delay.
				if ( 'delay' === trigger ) {
					setTimeout( function() {

						$this.openPopup( popup );

					}, $( popup ).data( 'open-delay-number' ) * 1000 );
				}

				// Exit Intent.
				if ( 'exit' === trigger ) {
					var showExit = true;
					document.addEventListener( "mousemove", function( e ) {
						// Get current scroll position
						var scroll = window.pageYOffset || document.documentElement.scrollTop;
						if ( ( e.pageY - scroll ) < 7 && showExit ) {
							$this.openPopup( popup );
							showExit = false;
						}
					} );
				}

				// Scroll Position.
				if ( 'scroll' === trigger ) {

					var pointScrollType     = $( popup ).data( 'open-scroll-type' );
					var pointScrollPosition = $( popup ).data( 'open-scroll-position' );

					// Event scroll.
					$( document ).on( 'scroll', function() {

						// Type px.
						if ( 'px' === pointScrollType ) {

							if ( window.scrollY >= pointScrollPosition ) {
								$this.openPopup( popup );
							}
						}

						// Type %.
						if ( '%' === pointScrollType ) {

							if ( $this.getScrollPercent() >= pointScrollPosition ) {
								$this.openPopup( popup );
							}
						}
					} );
				}

				// Accept Agreement.
				if ( 'accept' === trigger ) {
					let accept = $this.getCookie( 'popup-accept-' + $( popup ).data( 'id' ) || 0 );

					if ( ! accept ) {
						$this.openPopup( popup );
					}
				}
			},

			/*
			* Trigger close popup
			*/
			closeTriggerPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;

				var trigger = $( popup ).data( 'close-trigger' );

				// Time Delay.
				if ( 'delay' === trigger ) {
					setTimeout( function() {

						$this.closePopup(popup);

					}, $( popup ).data( 'close-delay-number' ) * 1000 );
				}

				// Scroll Position.
				if ( 'scroll' === trigger ) {

					var pointScrollType     = $( popup ).data( 'close-scroll-type' );
					var pointScrollPosition = $( popup ).data( 'close-scroll-position' );
					var initScrollPx        = $( popup ).data( 'init-scroll-px' );
					var initScrollPercent   = $( popup ).data( 'init-scroll-percent' );

					// Event scroll.
					$( document ).on( 'scroll', function() {

						// Type px.
						if ( 'px' === pointScrollType ) {

							if ( 'up' === $this.sDirection && window.scrollY < ( initScrollPx - pointScrollPosition ) ) {
								$this.closePopup( popup );
							}

							if ( 'down' === $this.sDirection && window.scrollY >= ( initScrollPx + pointScrollPosition ) ) {
								$this.closePopup( popup );
							}
						}

						// Type %.
						if ( '%' === pointScrollType ) {

							if ( 'up' === $this.sDirection && $this.getScrollPercent() < ( initScrollPercent - pointScrollPosition ) ) {
								$this.closePopup(popup);
							}

							if ( 'down' === $this.sDirection && $this.getScrollPercent() >= ( initScrollPercent + pointScrollPosition ) ) {
								$this.closePopup(popup);
							}
						}
					} );
				}
			},

			/*
			* Open popup
			*/
			openPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;


				// Hide body scroll.
				if ( $( popup ).is( '[data-body-scroll-disable="true"]' ) ) {
					$( 'body' ).addClass( 'popup-scroll-hidden' );
				}

				// Set Cookie of Limit display.
				let limit = parseInt( $this.getCookie( 'popup-' + $( popup ).data( 'id' ) ) || 0 ) + 1;

				$this.setCookie( 'popup-' + $( popup ).data( 'id' ), limit, {
					expires: $( popup ).data( 'limit-lifetime' )
				} );

				if ( $( popup ).hasClass( 'popup-open' ) ) {
					return;
				}

				// Check already opened.
				if ( $( popup ).hasClass( 'popup-already-opened' ) ) {
					return;
				}

				// Display popup.
				$( popup ).addClass( 'popup-open' );

				// Set current scroll.
				$( popup ).data( 'init-scroll-px', window.scrollY );
				$( popup ).data( 'init-scroll-percent', $this.getScrollPercent() );

				// Open animation.
				let animation = $( popup ).data( 'open-animation' );

				$this.applyAnimation( popup, animation );

				// Init close trigger.
				$this.closeTriggerPopup( popup );
			},

			/*
			* Age popup
			*/
			agePopup: function( e ) {
				let $el = ( e.originalEvent ) ? this : e;

				// Get popup container.
				let popup = $( $el ).closest( '.popup' );

				// Set Cookie of Age.
				$this.setCookie( 'popup-age-' + $( popup ).data( 'id' ), 1, {
					expires: 360
				} );
			},

			/*
			* Age declined
			*/

			ageDeclined: function() {
				$( '.age-verification__question' ).removeClass('show');
				$( '.age-verification__declined' ).addClass('show');
			},


			/*
			* Accept popup
			*/
			acceptPopup: function( e ) {

				let $el = ( e.originalEvent ) ? this : e;

				// Get popup container.
				let popup = $( $el ).closest( '.popup' );

				// Set Cookie of Accept.
				$this.setCookie( 'popup-accept-' + $( popup ).data( 'id' ), 1, {
					expires: 360
				} );
			},

			/*
			* Close popup
			*/
			closePopup: function( e ) {

				let $el = ( e.originalEvent ) ? this : e;

				// Get popup container.
				let popup = $( $el ).closest( '.popup' );

				if ( $( popup ).data( 'newsletter-close-timer' ) ) {
					clearTimeout( $( popup ).data( 'newsletter-close-timer' ) );
					$( popup ).removeData( 'newsletter-close-timer' );
				}

				// Close animation.
				let animation = $( popup ).data( 'exit-animation' );

				$this.applyAnimation( popup, animation, function() {
					// Already opened.
					$( popup ).addClass( 'popup-already-opened' );

					// Hide popup.
					$( popup ).removeClass( 'popup-open' );

					// Remove classes from body.
					$( 'body' ).removeClass( 'popup-scroll-hidden' );
				} );
			},

			/*
			* Checks whether a popup should be displayed or not
			*/
			isAllowPopup: function( e ) {
				let popup = ( e.originalEvent ) ? this : e;

				// Has user seen this popup before?
				let limitDisplay = parseInt( $( popup ).data( 'limit-display' ) || 0 );

				let limitDisplayCookie = parseInt( $this.getCookie( 'popup-' + $( popup ).data( 'id' ) ) );

				if ( limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay ) {
					return;
				}

				return true;
			},

			/*
			* Apply animation
			*/
			applyAnimation: function( el, name, callback ) {
				var popup = $( el ).closest( '.popup' );

				if ( typeof callback === 'function' ) {
					var overlayName = 'popupExitFade';
				} else {
					var overlayName = 'popupOpenFade';
				}

				// Overlay Animation.
				$( popup ).next( '.popup-overlay' ).addClass( 'popup-animated ' + overlayName )
					.one( 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
						$( this ).removeClass( 'popup-animated ' + overlayName );
					} );

				// Wrap Animation.
				$( popup ).find( '.popup-wrap' ).addClass( 'popup-animated ' + name )
					.one( 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
						// remove the animation classes after animation ends
						// required in order to apply new animation on close
						$( this ).removeClass( 'popup-animated ' + name );

						if ( typeof callback === 'function' ) {
							callback();
						}
					} );
			},

			/*
			* Set cookie
			*/
			getCookie: function( name ) {
				var matches = document.cookie.match( new RegExp(
					"(?:^|; )" + name.replace( /([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1' ) + "=([^;]*)"
				) );
				return matches ? decodeURIComponent( matches[ 1 ] ) : undefined;
			},

			/*
			* Set cookie
			*/
			setCookie: function( name, value, options ) {
				options = options || {};

				options.path = options.hasOwnProperty( 'path' ) ? options.path : '/';

				options.expires = parseInt( options.expires );

				if ( typeof options.expires == "number" && options.expires ) {

					options.expires = new Date().setDate(new Date().getDate() + options.expires );

					options.expires = new Date(options.expires).toUTCString();
				}

				value = encodeURIComponent( value );

				var updatedCookie = name + "=" + value;

				for ( var propName in options ) {
					updatedCookie += "; " + propName;
					var propValue = options[ propName ];
					if ( propValue !== true ) {
						updatedCookie += "=" + propValue;
					}
				}

				document.cookie = updatedCookie;
			},

			/*
			* Get scroll percent
			*/
			getScrollPercent: function() {
				var h = document.documentElement,
					b = document.body,
					st = 'scrollTop',
					sh = 'scrollHeight';
				return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
			}
		};

	} )();

	// Initialize.
	adpPopup.init();

	document.addEventListener('shopify:section:load', function () {
		adpPopup.init();
	});

	document.addEventListener('shopify:section:unload', function () {	
		$( 'body' ).removeClass( 'popup-scroll-hidden' );
	})
});
